import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as a, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "cc84f9d0-42bd-4ef1-876f-3ec9cf13237d" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#cc84f9d0-42bd-4ef1-876f-3ec9cf13237d)" }, p = { key: 0 }, v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h512v144.7H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 367.3h512V512H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M272.7 250.4v-61.2h-33.4v61.2L199 290.8a66.7 66.7 0 0 0 114 0z"
}, null, -1), w = { fill: "none" }, y = ["r"], N = /* @__PURE__ */ d({
  __name: "ls",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (z, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", p, a(t.flagName), 1)) : f("", !0),
        v,
        k,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=ls-3995d955.js.map
